import React from "react";

import { STATE_COLORS, stateForScore } from "../reportFormat";

/**
 * Day-by-day wellness strip for the last fortnight.
 *
 * The point of the strip is the pattern of GAPS as much as the colours: an
 * athlete whose bad days cluster on Mondays and one who simply stopped logging
 * look identical in a monthly average and completely different here. Missing
 * days therefore get their own neutral swatch and are named in the legend.
 */
const Heatmap = ({ series = [], dates = [] }) => {
  if (series.length === 0) {
    return <p className="py-3 text-[12px] text-peri-300">Sin check-in registrado en el periodo.</p>;
  }

  return (
    <div
      className="mt-1.5 grid gap-1"
      style={{ gridTemplateColumns: `repeat(${series.length}, minmax(0, 1fr))` }}
      role="img"
      aria-label={`Índice de estado de los últimos ${series.length} días`}
    >
      {series.map((score, index) => {
        const recorded = typeof score === "number" && Number.isFinite(score);
        const state = recorded ? stateForScore(score) : null;
        const date = dates[index];
        return (
          <div
            key={index}
            className="aspect-square rounded-[3px]"
            style={{ background: recorded ? state.color : STATE_COLORS.missing }}
            title={
              recorded
                ? `${date ?? `Día ${index + 1}`}: ${Math.round(score)}% · ${state.name}`
                : `${date ?? `Día ${index + 1}`}: sin registro`
            }
          />
        );
      })}
    </div>
  );
};

export default Heatmap;
